import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  itemColumnLabel: PropTypes.node.isRequired,
  priceColumnLabel: PropTypes.node.isRequired,
  isNegative: PropTypes.bool,
  itemSummaryLabel: PropTypes.node,
  priceSummaryLabel: PropTypes.node
};
function TransactionSummary(_ref) {
  var children = _ref.children,
    _ref$isNegative = _ref.isNegative,
    isNegative = _ref$isNegative === void 0 ? false : _ref$isNegative,
    itemColumnLabel = _ref.itemColumnLabel,
    _ref$itemSummaryLabel = _ref.itemSummaryLabel,
    itemSummaryLabel = _ref$itemSummaryLabel === void 0 ? null : _ref$itemSummaryLabel,
    priceColumnLabel = _ref.priceColumnLabel,
    _ref$priceSummaryLabe = _ref.priceSummaryLabel,
    priceSummaryLabel = _ref$priceSummaryLabe === void 0 ? null : _ref$priceSummaryLabe;
  var negativeClassName = isNegative ? 'transaction-summary-negative' : '';
  return /*#__PURE__*/React__default.createElement("table", {
    className: "transaction-summary",
    role: "presentation"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "transaction-summary-col-header-text"
  }, itemColumnLabel), /*#__PURE__*/React__default.createElement("th", {
    className: "transaction-summary-col-header-text"
  }, priceColumnLabel))), /*#__PURE__*/React__default.createElement("tbody", null, children), itemSummaryLabel && priceSummaryLabel && /*#__PURE__*/React__default.createElement("tfoot", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "transaction-summary-footer",
    "data-testid": "transaction-summary-footer"
  }, /*#__PURE__*/React__default.createElement("th", {
    scope: "row",
    className: "transaction-summary-item-label ".concat(negativeClassName)
  }, itemSummaryLabel), /*#__PURE__*/React__default.createElement("td", {
    className: "transaction-summary-item-amount ".concat(negativeClassName)
  }, priceSummaryLabel))));
}
TransactionSummary.propTypes = propTypes;

export { TransactionSummary as default };
//# sourceMappingURL=TransactionSummary.js.map
